module.exports = __webpack_public_path__ + "img/energikonsult.55654428.png";